/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import {
  Link as MuiLink,
  Breadcrumbs as MuiBreadcrumbs,
  BreadcrumbsProps as MuiBreadcrumbsProps,
  Stack,
  styled,
} from '@mui/material';
import React from 'react';
import MaterialSymbol from './MaterialSymbol';
import Typography from './Typography';
import { colors } from '@farmlands/mui-theme';
import { TestIds } from '../testIds';

const Link = styled(MuiLink)(({ theme }) => ({
  ...theme.typography.body2,
  color: colors.primary500,
  fontWeight: 'bold',
}));

interface BreadcrumbsProps extends MuiBreadcrumbsProps {
  items: {
    text: string;
    href?: string;
  }[];
}
export const Breadcrumbs: React.FC<BreadcrumbsProps> = ({ items, ...props }: BreadcrumbsProps) => {
  return (
    <Stack>
      <MuiBreadcrumbs
        separator={<MaterialSymbol>chevron_right</MaterialSymbol>}
        aria-label='breadcrumb'
        {...props}
        data-testid={TestIds.components.breadcrumbs.container}
      >
        {items
          .filter((x, index) => x.text !== '' && index !== items.length - 1)
          .map((x) => (
            <Link
              underline='hover'
              color={colors.primary500}
              href={x.href}
              key={x.text}
              id={TestIds.components.breadcrumbs.item(x.text)}
            >
              {x.text}
            </Link>
          ))}

        <Typography variant='body2' fontWeight={700} color='primary500'>
          {items[items.length - 1].text}
        </Typography>
      </MuiBreadcrumbs>
    </Stack>
  );
};
